import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles((theme) => ({
  generalWrapper: {
    padding: "24px 24px 0 24px",
  },
  headerBreadcrumbs: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  headerBreadcrumbsTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: "bold",
    color: getBrandCustom("primaryColor", "#38cfc4"),
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
  },
}));

export default styles;
